export default ({
  data: { publishDate, success, updatedAt }
}) => {
  if (!success) return {editorHeaderStatus: 'error', editorIsPublishing: false};

  return {
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorPublishDate: publishDate,
    editorIsPublishing: false
  }; 
};
